// extracted by mini-css-extract-plugin
export default {"ag-styles":"Y_M","toolbar":"Y_NB","controlsContainer":"Y_NC","controls":"Y_Q","scrollIndicator":"Y_ND","videoTour":"Y_NF"};